/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Metadata } from "@emt/emt-metadata-client";
import { MetadataAction, STORE_METADATA } from "../actions/actions";

export const emptyMetadata: Metadata = {
    offerings: [],
    activityCategories: [],
    activityTypes: [],
    expenseTypes: [],
    currencies: [],
    coopProofRules: [],
    curencyCountryCodes: [],
    rejectionReasons: [],
    programFundCategories: [],
};

export function metadata(state: Metadata = emptyMetadata, action: MetadataAction): Metadata {
    switch (action.type) {
        case STORE_METADATA: {
            return action.payload;
        }
        default:
            return state;
    }
}
